import React from 'react';
import { To } from 'react-router-dom';
import { Paths } from 'shared/routes/paths';

export enum MainNavigationItemId {
  Todo = 'todo',
  Inbox = 'inbox',
  Today = 'today',
  Upcoming = 'upcoming',
  AllTasks = 'all-tasks',
  Completed = 'completed',
  Plan = 'plan',
  Timeline = 'timeline',
  MyLife = 'my-life',
  LifeAreas = 'life-areas',
  Goals = 'goals',
  GoalsCalendar = 'goals-calendar',
  Projects = 'projects',
  Habits = 'habits',
  Insights = 'insights',
}

export type SubNavigationItem = {
  id: MainNavigationItemId;
  translationLabel: string;
  link?: To;
  pathsToMatch?: Paths[];
  icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  comingSoon?: boolean;
};

export type NavigationItem = {
  id: MainNavigationItemId;
  translationLabel: string;
  link?: To;
  pathsToMatch?: Paths[];
  subItems: SubNavigationItem[];
};

export type MobileNavigationItem = {
  id: MainNavigationItemId;
  translationLabel: string;
  link: To;
  pathsToMatch: Paths[];
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
};
